export class SaveCommandeDenreeModel {

  idGroupeAchat_CatalogueAchat: number;

  dateLivraisonPossible: Date;

  quantiteUC: number;

}
